module.exports = __webpack_public_path__ + "img/hypefury.1bf67ad0.png";